import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import { IBanksClient } from "../types";

@injectable()
export default class BanksClient implements IBanksClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async getBankAccounts(): Promise<IJsonResponse> {
    const banksResponse = await this.http.get(`/v1/app/banks?page=${1}`);
    const bankAccountsResponse = await this.http.get(
        `/v1/app/bankaccounts?page=${1}`
      );
    // const deletedBankAccountsResponse = await this.http.get("/bankaccounts/deleted");

    const banksData = banksResponse.data;
    const bankAccountsData = bankAccountsResponse.data;
    // const deletedBankAccountsData = deletedBankAccountsResponse.data;
    this.store.commit("BankModule/setBankDetails", {
      bankAccounts: bankAccountsData,
      banks: banksData,
      deletedBanks: [],
    });
    return bankAccountsResponse;
  }

  async getNewBankAccounts(): Promise<IJsonResponse> {
    const banksResponse = await this.http.get(`/v1/app/banks?page=${1}`);
    const newBankAccountsResponse = await this.http.get(
      `/v1/app/newbankaccounts?page=${1}`
    );

    const banksData = banksResponse.data;
    const newBankAccountsData = newBankAccountsResponse.data;
    this.store.commit("BankModule/setNewBankDetails", {
      newBankAccounts: newBankAccountsData,
      banks: banksData,
      deletedBanks: [],
    });
    return newBankAccountsResponse;
  }

  async updateBank(
    id: number,
    accountName: string,
    accountNumber: string,
    bankId: number,
    accountType: "savings" | "current",
    password: string
  ): Promise<IJsonResponse> {
    return await this.http.patch(`/v1/app/newbankaccounts/${id}`, {
      accountName,
      accountNumber,
      accountType,
      bankId,
      password,
    });
  }

  async addBank(
    accountName: string,
    accountNumber: string,
    bankId: number,
    accountType: "savings" | "current"
  ): Promise<IJsonResponse> {
    return await this.http.post(`/v1/app/newbankaccounts`, {
      accountName,
      accountNumber,
      accountType,
      bankId,
    });
  }

  async makeBankDefault(id: number, password?: string): Promise<IJsonResponse> {
    return await this.http.patch(`/v1/app/newbankaccounts/default/${id}`);
  }

  async deleteBank(id: number): Promise<IJsonResponse> {
    return await this.http.delete(`/v1/app/newbankaccounts/${id}`);
  }

  async restoreBank(id: number): Promise<IJsonResponse> {
    const response = await this.http.put(
      `/v1/app/newbankaccounts/restore/${id}`
    );
    this.store.commit("BankModule/pushBankAccounts", [response.data]);
    return response;
  }

  async discardBank(id: number): Promise<IJsonResponse> {
    return await this.http.delete(`/v1/app/newbankaccounts/final/${id}`);
  }
}
